import { CdkMenuModule } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { Component, inject, model, output } from '@angular/core';
import { CenterUserService } from '@malirang/api-client';
import { Button } from '@malirang/front-share';
import { ColorPickerDirective } from 'ngx-color-picker';
import { CenterUserStore } from '../../stores/center/center-user.store';
import { CenterStore } from '../../stores/center/center.store';
import { ColorPickerItemComponent } from './color-picker-item/color-picker-item.component';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  imports: [
    CdkMenuModule,
    CommonModule,
    Button,
    ColorPickerDirective,
    ColorPickerItemComponent,
  ],
})
export class ColorPickerComponent {
  readonly centerUserService = inject(CenterUserService);
  readonly centerUserStore = inject(CenterUserStore);
  readonly centerStore = inject(CenterStore);

  centerId = this.centerStore.currentCenterId;
  centerUser = this.centerUserStore.currentCenterUser;

  setColor = output<string>();

  cpColor = model<string>('');
  cpToggle = model<boolean>(false);

  /**
   * 기본 색상
   */
  colors: string[] = [
    '#D75E63',
    '#F43F5E',
    '#FB923C',
    '#FCD34D',
    '#84CC16',
    '#16A34A',
    '#1693C9',
    '#2563EB',
    '#7C3AED',
    '#C026D3',
  ];

  addColor() {
    this.centerUserService
      .centerUserControllerAddColor({
        color: this.cpColor(),
        centerUserId: this.centerUser()?.id || '',
        centerId: this.centerId(),
      })
      .subscribe({
        next: async () => {
          this.cpToggle.set(false);
          await this.centerUserStore.fetchCenterUser();
        },
      });
  }

  removeColor(color: string) {
    this.centerUserService
      .centerUserControllerDeleteColor({
        color,
        centerUserId: this.centerUser()?.id || '',
        centerId: this.centerId(),
      })
      .subscribe({
        next: async () => {
          await this.centerUserStore.fetchCenterUser();
        },
      });
  }
}
